import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, Subject, tap } from 'rxjs';
import { APIRequestResources, CachedAPIRequest, LoadingService } from 'src/app/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { handleError } from 'src/app/core/utils/utils';
import { CreateShiftDTO, GetShiftDTO, ShiftGetbyDepDTO, UpdateShiftDTO } from '../interface/shift.entity';

@Injectable({
  providedIn: 'root'
})
export class ShiftService extends CachedAPIRequest {

    constructor(protected override http: HttpClient, private router: Router) {
      super(http, APIRequestResources.ShiftService)
    }

    loading = inject(LoadingService);
    private refreshTrigger = new Subject<void>();
      
    $all = new BehaviorSubject<GetShiftDTO[]>([]);
    all = toSignal(this.$all, {initialValue: []});

    $active = new BehaviorSubject<any | undefined>(undefined);
    active = toSignal(this.$active, {initialValue: undefined});

    getAll(departmentId: number | null = null, refresh = true) {
      return this.get<GetShiftDTO>({
          params: departmentId ? { department: departmentId } : {}
        },
        refresh ? 'freshness' : 'performance'
      ).pipe(
        tap(res => this.$all.next([{ shifts: res.data.shifts }])),
        catchError(handleError)
      );
    }

    create = (shifts: CreateShiftDTO) => {
          const payload = {
            shifts: [shifts]
          }
          return this.post<any>(payload, {}).pipe(
          );
    }

    update = (id: number, updateShiftDTO: UpdateShiftDTO) => {
        const options = {suffix: `/${id}`}
        return this.put<any>(updateShiftDTO, options).pipe(
        )
    }

    getById = (id: string, refresh = false) => {
      const options = { endpoint: `by_machine/${id}` };
      return this.get<ShiftGetbyDepDTO>(options,refresh ? 'freshness' : 'performance'
      ).pipe(
        tap((res) => {
          this.$active.next(res.data);
        })
      );
    };
    

}
